import { render, staticRenderFns } from "./TailwindList.vue?vue&type=template&id=00ac040c&scoped=true"
import script from "./TailwindList.vue?vue&type=script&lang=js"
export * from "./TailwindList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ac040c",
  null
  
)

export default component.exports